<template>
  <div class="container errorPage">
    <h1>{{ code }}</h1>
    <p v-html="tagLine"></p>
    <br />

    <p v-if="form">You should get re-admintted:</p>
    <form v-if="form" method="POST" @click="search">
      <input type="text" v-model="searchInput" />
      <button type="button">Search</button>
    </form>
    <br />

    <button @click="$router.go(-1)">
      <i class="fa fa-angle-left"></i> Go Back
    </button>

    <!-- Extra -->
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "Error",
  props: {
    code: {
      type: Number,
      required: false,
      default: 404
    },
    tagLine: {
      type: String,
      required: false,
      default: "You dropped out"
    },
    form: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      searchInput: ""
    };
  },
  methods: {
    search() {
      this.$store.commit("showAlert", {
        message: "Failed",
        status: "danger"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.errorPage {
  background-color: #0c146170;
  padding-top: 30px;
  text-align: center;
  min-height: calc(100vh - 200px);

  h1 {
    font-size: 72px;
    margin: 15px 0;
  }

  form {
    display: flex;
    width: 320px;
    margin: 0 auto;

    input {
      flex: 1 0 auto;
    }
    button {
      flex: 0 1 80px;
      margin: 0;
    }
  }

  button {
    padding: 15px;
    color: #ffffff;
    background-color: #fe5244;
    font-weight: bold;
    border: none;
    cursor: pointer;
    margin: 10px;
    outline: 0;

    &.closeBtn {
      color: #000000;
      background-color: #ffffff;
    }
  }
}
</style>
